import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import DialogModal from "../../common/DialogModal";
import ContactInfoInner from "../../SendLetter/dialogs/ContactInfoInner";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: "20px 25px 30px 25px",
    margin: 0,
    textAlign: "left",
  },
});

class IntegrationInquiryDialog extends React.Component {
  render() {
    const { classes, toggleDialog, isOpen } = this.props;

    return (
      <DialogModal
        title="プラン変更申請"
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <ContactInfoInner text="プラン変更をご検討いただき誠にありがとうございます。セールスフォース連携にご興味があるお客様は右下のチャットフォームまたは下記いずれかの連絡先より、貴社名とご希望のプランをご連絡ください。ご質問のみでもけっこうでございます。ご連絡お待ちしております。" />
      </DialogModal>
    );
  }
}

IntegrationInquiryDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default withStyles(styles)(IntegrationInquiryDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Integration/IntegrationInquiryDialog.jsx